export default "__VITE_ASSET__CkBixZvY__"